<style lang="less" scoped>
  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .stop, .complete {
    font-size: 20px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
  }
</style>

<template lang="pug">
  .header
    .stop(@click='handleStop') 그만하기
    .complete(@click='handleComplete') 리콜완료
</template>

<script>
export default {
  methods: {
    handleStop() {
      this.$emit('click-stop');
    },
    handleComplete() {
      this.$emit('click-complete');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/header/stop_complete.vue